<template>
    <section id="recinto">
        <ContentOrLoading :style="loading ? 'padding: 200px;' : ''">
            <div v-if="error" class="error container" role="alert">
                <p>{{ error }}</p>
                <button type="button" @click="getSecciones()">Reintentar</button>
            </div>
            <div class="container" v-else-if="!loading">
                <div class="row" v-if="!seccion_seleccionada">
                    <div class="col-12">
                        <h2 class="m-0 h1 text-uppercase">{{ $t('partido.pinchando_mapa') }}</h2>
                    </div>

                    <div class="col-12">
                        <transition name="fade" mode="out-in">
                            <div class="row" key="secciones" id="secciones">
                                <div class="col-lg-12">
                                    <div class="lightgray-content">
                                        <SvgSectionsComponent
                                            :key="'svg-sections-' + svgKey"
                                            :secciones="secciones"
                                            @clickZona="seccionSeleccionada"
                                        />												
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>

                <div v-else>
                    <template v-if="! seccion_seleccionada.tiene_secciones">
                        <div v-if="!hideHeader" class="col-12 justify-content-between d-flex">
                            <span class="m-0 h1 text-uppercase">{{ $t('nuevo_abono.elige_asientos') }}</span>
                            <button v-if="!soloParking" @click="volver" class="h6 button small-button m-0"><i class="fa fa-redo"></i> Volver</button>
                        </div>

                        <b-col cols="12" class="pt-3" v-if="!soloParking">
                            <b-breadcrumb>
                                <b-breadcrumb-item 
                                    v-for="(item, index) in breadcrumbs" 
                                    :key="index" 
                                    @click="breadcrumbs.length -1 == index ? null : goTo(item, index)"
                                    :active="breadcrumbs.length -1 == index"
                                >
                                    {{ item.name }}
                                </b-breadcrumb-item>
                            </b-breadcrumb>
                        </b-col>

                        <div class="col-12" v-show="!cargando_zonas">
                            <transition name="fade" mode="out-in">
                                <div class="row" key="seccion" id="zonas"> 
                                    <b-col cols="12">
                                        <h3 class="subtitle h3 light mb-3 ">A) {{ $t('partido.pinchando_mapa') }}:</h3>
                                    </b-col>
                                    <div class="col-lg-8" v-if="!cargando_zonas">
                                        <div class="lightgray-content">
                                            <SvgSectionComponent
                                                :key="'svg-section-1-' + svgKey"
                                                :zonas="zonas_formated"
                                                :seccion="seccion_seleccionada"
                                                @clickZona="regionFinalSeleccionada"
                                                @cargado="cargando_zonas = false"
                                            />												
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-4">
                                        <h3 class="subtitle h3 light mb-3 ">B) {{ $t('partido.tabla') }}:</h3>
                                        <div class="lightgray-content p-2 pb-0">
                                            <TablaSectoresComponent 
                                                :zonas="zonas_formated" 
                                                @clickZona="regionFinalSeleccionada"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </transition>
                        </div>
                        <div v-if="cargando_zonas" class="col-12 text-center" style="height: 400px">
                            <LoaderComponent/>
                        </div>
                    </template>
                    <template v-else>
                        <div v-if="!hideHeader" class="col-12 justify-content-between d-flex">
                            <h2 class="m-0 h1 text-uppercase text-center pb-3">{{ $t('partido.pinchando_mapa') }}</h2>
                            <button v-if="!soloParking" @click="volver" class="h6 button small-button m-0"><i class="fa fa-redo"></i> Volver</button>
                        </div>

                        <b-col cols="12" class="pt-3" v-if="!soloParking">
                            <b-breadcrumb>
                                <b-breadcrumb-item 
                                    v-for="(item, index) in breadcrumbs"
                                    :key="index" 
                                    @click="breadcrumbs.length -1 == index ? null : goTo(item, index)"
                                    :active="breadcrumbs.length -1 == index"
                                >
                                    {{ item.name }}
                                </b-breadcrumb-item>
                            </b-breadcrumb>
                        </b-col>

                        <div class="col-12" v-show="!cargando_zonas">
                            <transition name="fade" mode="out-in">
                                <div class="row" key="secciones" id="zonas">
                                    <div class="col-lg-12">
                                        <div class="lightgray-content">
                                            <SvgSectionComponent
                                                :key="'svg-section-2-' + svgKey"    
                                                :zonas="secciones"
                                                :seccion="seccion_seleccionada"
                                                @clickZona="seccionSeleccionada"
                                                @cargado="cargando_zonas = false"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </transition>
                        </div>
                        <div v-if="cargando_zonas" class="col-12 text-center" style="height: 400px">
                            <LoaderComponent/>
                        </div>
                    </template>
                </div>
            </div>
        </ContentOrLoading>
    </section>
</template>

<script>
    import SvgSectionsComponent from './SvgSectionsComponent.vue';
    import SvgSectionComponent from './SvgSectionComponent.vue';
    import TablaSectoresComponent from '@/components/frontend/abonos/nuevo/TablaSectoresComponent';

    // The "no prices = not available" normalization only applies to these
    // teatros. Other clubs keep the legacy behaviour untouched.
    const HASHES_WITH_STRICT_PRICES = ['J1fKG9AarPuPNJ5hwY0t', 'D5IcOz5iKX8EdfkoQ6NF'];

    export default {
        props: {
            recuperarSoloZonaAnexas: {
                type: Boolean,
                default: false
            },
            /**
             * Si es true, el abonado actual tiene `descuento.renovacion === true`.
             * Cuando es true, se envía `renovacion=true` en la query del endpoint
             * `front.temporada.recinto.secciones.zonas.anexas` para que el backend
             * devuelva sólo los precios de renovación en la respuesta.
             *
             * Si es false o null, NO se envía el param (back-compat con callers que
             * aún no propagan el flag).
             */
            renovacion: {
                type: Boolean,
                default: false
            },
            /**
             * Oculta la cabecera del wrapper (título "ELIGE TUS ASIENTOS" /
             * "PINCHA EN EL MAPA" + botón "Volver").
             *
             * Esa cabecera pertenece al flujo de alta de abonos nuevos. En el
             * flujo de CAMBIO de asiento (perfil) el stepper del wizard ya
             * aporta su propia cabecera/navegación, así que este wrapper la
             * oculta para no duplicar títulos ni botones. Los breadcrumbs se
             * mantienen para poder navegar entre secciones.
             */
            hideHeader: {
                type: Boolean,
                default: false
            },
            svgKey: {
                type: Number,
                default: 0
            } 
        },
        data() {
            return {
                loading: false,
                error: null,
                seccion_seleccionada: false,
                secciones: [],
                breadcrumbs: [],
                cargando_zonas: false,
                zonas: [],
                zonas_anexas: []
            }
        },
        created() {
            this.getSecciones();

            this.breadcrumbs.push({
                name: 'Inicio'
            })
        },
        computed: {
            soloParking() {
                return this.recuperarSoloZonaAnexas;
            },
            appliesStrictPrices() {
                var hash = (this.$store.getters.getConfig || {}).hash_teatro;
                return HASHES_WITH_STRICT_PRICES.indexOf(hash) !== -1;
            },
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            recinto() {
                return this.$store.getters.getRecinto;
            },
            zonas_formated() {
                var array = [];
                for(var zona in this.zonas) {
                    array.push(this.zonas[zona]);

                    // A zone is only selectable if it has sellable prices for the
                    // current abonado. Without this check, a zone with
                    // tipos_abonos > 0 but no applicable descuentos (precios = [])
                    // would render as available (hover + popover) while the click
                    // guard in ShowSvgSectionComponent rejects it.
                    // Scoped to specific teatros (see HASHES_WITH_STRICT_PRICES).
                    if (this.appliesStrictPrices) {
                        var hasPrices = (array[zona].precios || []).length > 0;
                        var disponible = array[zona].tipos_abonos.length > 0 && array[zona].esta_disponible && array[zona].libres > 0 && hasPrices ? true : false;
                    } else {
                        // Legacy formula (unchanged for other teatros).
                        disponible = array[zona].tipos_abonos.length > 0 && array[zona].esta_disponible && array[zona].libres > 0 ? true : false;
                    }
                    array[zona].esta_disponible = disponible;
                }

                return array;
            },
        },
        methods: {
            getSecciones() {
                this.loading = true;

                const params = {
                    filters: {},
                    recinto_id: this.recinto.id,
                    lista_abonado_id: this.lista_abonados.id
                };

                if (this.soloParking) {
                    params.filters.solo_parking = 1;
                }

                this.$store.dispatch(this.config.getVuexAlias('front.temporada.recinto.secciones'), params).then(res => {
                    this.secciones = res.data.data;
                    this.error = null;

                    if (this.secciones.some(s => s.tiene_parking)) {
                        this.zonas_anexas = [{ esta_disponible: true }];
                    }
                }).catch(err => {
                    this.error = (err && err.message) || 'Error al cargar las secciones del recinto.';
                    if (process.env.NODE_ENV !== 'production') {
                        console.error('[SeccionesComponent] getSecciones failed:', err);
                    }
                }).finally(() => {
                    this.loading = false;
                });
            },
            seccionSeleccionada(seccion) {
                this.cargando_zonas = true;
                this.zonas = [];

                if (this.soloParking) {
                    this.zonas_anexas = [];
                    this.getSeccionRegionesAnexas(seccion).catch(err => {
                        this.error = (err && err.message) || 'Error al cargar las regiones anexas.';
                    }).finally(() => {
                        this.cargando_zonas = false;
                    });
                } else {
                    this.breadcrumbs.push({
                        name: seccion.name,
                        id: seccion.id,
                        tiene_secciones: seccion.tiene_secciones
                    })
                    Promise.all([
                        this.getSeccionRegiones(seccion),
                        this.getSeccionRegionesAnexas(seccion)
                    ]).catch(err => {
                        this.error = (err && err.message) || 'Error al cargar las zonas de la sección.';
                    }).finally(() => {
                        this.cargando_zonas = false;
                    });
                }

                this.seccion_seleccionada = seccion;
            },
            getSeccionRegiones(seccion) {
                const params = {
                    filters: {},
                    seccion_id: seccion.id,
                    recinto_id: this.recinto.id,
                    lista_abonado_id: this.lista_abonados.id
                }

                if (this.soloParking) {
                    params.filters.solo_parking = 1;
                }

                return this.$store.dispatch(this.config.getVuexAlias('front.temporada.recinto.secciones.zonas'), params).then(res => {
                    if(! seccion.tiene_secciones) {
                        this.zonas = this.zonas.concat(res.data.data);
                    } else {
                        this.secciones = res.data.data;
                    }
                });
            },
            getSeccionRegionesAnexas(seccion) {
                const params = {
                    filters: {},
                    seccion_id: seccion.id,
                    recinto_id: this.recinto.id,
                    lista_abonado_id: this.lista_abonados.id
                }

                if (this.soloParking) {
                    params.filters.solo_parking = 1;
                }

                // Si el abonado tiene `descuento.renovacion === true`, pedimos al
                // backend sólo los precios de renovación. Es la fuente de verdad
                // del filtrado en backend (el cliente también puede filtrar, pero
                // este param evita traer precios que el abonado no puede usar).
                if (this.renovacion === true) {
                    params.filters.renovacion = true;
                }

                return this.$store.dispatch(this.config.getVuexAlias('front.temporada.recinto.secciones.zonas.anexas'), params).then(res => {
                    let anexas = res.data.data;

                    anexas.forEach(zona => {
                        zona.precios = [];
                        zona.tipos_abonos.forEach(precio => {
                            zona.precios = zona.precios.concat(precio.descuentos);
                        });
                    });

                    if (this.soloParking) {
                        this.zonas_anexas = anexas;
                        this.zonas = anexas;
                    } else {
                        this.zonas_anexas = anexas;
                        this.zonas = this.zonas.concat(anexas);
                    }
                });
            },
            regionFinalSeleccionada(zona) {
                this.$emit('terminar', zona, this.zonas_anexas);
            },
            volver() {
                if (this.soloParking) {
                    this.$emit('terminar', null, []);
                    return;
                }
                var index = this.breadcrumbs.length - 2;
                if (index >= 0 && this.breadcrumbs[index]) {
                    this.goTo(this.breadcrumbs[index], index);
                } else {
                    this.reset();
                }
            },
            goTo(item, index) {
                if (item.name == 'Inicio') {
                    this.reset();
                } else {
                    this.breadcrumbs.splice(index);
                    this.seccionSeleccionada(item);
                }
            },
            reset() {
                this.breadcrumbs = [{
                    name: 'Inicio'
                }];
                this.seccion_seleccionada = null;
                this.zonas = [];
                this.getSecciones();
            },
        },
        components: {
            SvgSectionsComponent, SvgSectionComponent, TablaSectoresComponent
        }
    }
</script>